const system = {
  namespaced: true,
  state: {
      virtualStopsList: null
  },
  mutations: {
    setVirtualStops(state, newList) {
      state.virtualStopsList = newList;
    },
  },
  actions: {
    saveVirtualStops(context, gpscheckpoint) {
        return new Promise((resolve, reject) => {
          this._vm.$traveller_http.post('/traveller/restui/gpscheckpoint/save', gpscheckpoint)
            .then(response => {
                context.dispatch('getVirtualStops');
                resolve(response);
            }),
            error => {
              reject(error);
            }
        });
      },
    deleteVirtualStops(context, gpsCheckpointId ) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http.get('/traveller/restui/gpscheckpoint/delete', { params: {"gpscheckpointid":gpsCheckpointId}}  )
          .then(response => {
              context.dispatch('getVirtualStops');
              resolve(response);
          }),
          error => {
            reject(error);
          }
      });
    },
    getVirtualStops(context) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http.get('/traveller/restui/gpscheckpoint/getGpsCheckpoints')
          .then(response => {
              context.commit('setVirtualStops', response.data);
              resolve(response.data);
              return;
          }),
          error => {
            reject(error);
          }
      });
    }
  }
}

export default system;